import { extend, localize, ValidationProvider, ValidationObserver }  from "vee-validate";
import {
  alpha_spaces, alpha_num, confirmed, email, required, required_if,
  max, max_value, min, min_value, numeric, ext
} from 'vee-validate/dist/rules';
// import ru from 'vee-validate/dist/locale/ru.json';
// import en from 'vee-validate/dist/locale/en.json';
import Vue from 'vue';

const smppNameRegex = new RegExp('^[A-Za-z0-9_\\-]+$');
const maxThroughputRegex = new RegExp('^\\d+/[1-9]\\d*$');
const numberRegex = new RegExp('^\\d{1,15}$');
const symbolRegex = new RegExp('^[A-Za-z0-9._\\-\\s]{1,11}$');
const nonCyrillicRegex = new RegExp('^[^А-Яа-яёЁ]*$');

extend('alpha_spaces', alpha_spaces);
extend('alpha_num', alpha_num);
extend('alpha_and_num', value => /^(?![0-9]*$)(?![a-zA-Z]*$)[a-zA-Z0-9]+$/i.test(value));
extend('alpha_num_spaces', value => /^[0-9A-ZА-Я\s]*$/i.test(value));
extend('alpha_num_dash', value => /^[0-9A-ZА-Я_\-]*$/i.test(value));
extend('alpha_num_dash_dot', value => /^[0-9A-ZА-Я_\.\-]*$/i.test(value));
extend('alpha_num_dash_spaces', value => /^[0-9A-ZА-Я_Ёё\-\s]*$/i.test(value));
extend('template', value => /^[0-9A-ZА-Я_Ёё\s#№]*$/i.test(value));
extend('not_zero', value => value != 0);
extend('confirmed', confirmed);
extend('email', email);
extend('required', required);
extend('required_if', required_if);
extend('max', max);
extend('min', min);
extend('max_value', max_value);
extend('min_value', min_value);
extend('numeric', numeric);
extend('sms_originator', value => numberRegex.test(value) || symbolRegex.test(value));
extend('non_cyrillic', value => nonCyrillicRegex.test(value));
extend('viber_originator', value => symbolRegex.test(value));
extend('max_throughput', value => maxThroughputRegex.test(value));
extend('smpp_name', value => smppNameRegex.test(value));
extend('non_space', value => !/\s/.test(value));
extend('has_num', value => /[1-9]/.test(value));
extend('has_char', value => /[\D]/.test(value));
extend('phone_numbers', value => /^[\d, ]*$/.test(value));

localize({
  ru: {
    messages: {
      "alpha": "Поле {_field_} может содержать только буквы",
      "alpha_dash": "Поле {_field_} может содержать только буквы, цифры и дефис",
      "alpha_num": "Поле {_field_} может содержать только буквы и цифры",
      "alpha_spaces": "Поле {_field_} может содержать только буквы и пробелы",
      "between": "Поле {_field_} должно быть между {min} и {max}",
      "confirmed": "Поле {_field_} не совпадает с {target}",
      "digits": "Поле {_field_} должно быть числовым и длиной {length}",
      "dimensions": "Поле {_field_} должно быть {width} пикселей на {height} пикселей",
      "email": "Поле {_field_} должно быть действительным электронным адресом",
      "excluded": "Поле {_field_} должно быть допустимым значением",
      "ext": "Поле {_field_} должно быть действительным файлом",
      "image": "Поле {_field_} должно быть изображением",
      "oneOf": "Поле {_field_} должно быть допустимым значением",
      "integer": "Поле {_field_} должно быть целым числом",
      "length": "Длина поля {_field_} должна быть {length}",
      "max": "Поле {_field_} не может быть более {length} символов",
      "max_value": "Поле {_field_} должно быть {max} или менее",
      "mimes": "Поле {_field_} должно иметь допустимый тип файла",
      "min": "Поле {_field_} должно быть не менее {length} символов",
      "min_value": "Поле {_field_} должно быть {min} или больше",
      "numeric": "Поле {_field_} должно быть числом",
      "regex": "Поле {_field_} имеет ошибочный формат",
      "required": "Поле {_field_} обязательно для заполнения",
      "required_if": "Поле {_field_} обязательно для заполнения",
      "size": "Поле {_field_} должно быть меньше, чем {size}KB",
      "double": "Поле {_field_} должно быть допустимым десятичным числом",

      alpha_and_num: 'Поле {_field_} должно содержать только буквы и цифры',
      alpha_num_spaces: 'Поле {_field_} может содержать только буквы, цифры и пробелы',
      alpha_num_dash: 'Поле {_field_} может содержать только буквы, цифры, дефис и нижнее подчеркивание',
      alpha_num_dash_dot: 'Поле {_field_} может содержать только буквы, цифры, точку, дефис и нижнее подчеркивание',
      alpha_num_dash_spaces: 'Поле {_field_} может содержать только буквы, цифры, пробелы, дефис и нижнее подчеркивание',
      template: 'Поле {_field_} может содержать только буквы, цифры, пробелы, символы _ # №',
      not_zero: 'Поле {_field_} не может быть 0',
      sms_originator: 'Длина адреса отправителя должна быть не более 15 цифр или 11 символов (цифры и символы латинского алфавита, пробел, точка, дефис, нижнее подчеркивание)',
      non_cyrillic: 'Поле {_field_} не может содержать кириллические символы',
      viber_originator: 'Длина адреса отправителя должна быть не более 11 символов (цифры и символы латинского алфавита, пробел, точка, дефис, нижнее подчеркивание)',
      max_throughput: 'Некорректное значение. Корректный формат x/y',
      smpp_name: 'Некорректое значение. Допустима латиница, дефис, нижнее подчеркивание',
      non_space: 'Поле {_field_} не может содержать пробелы',
      has_num: 'Поле {_field_} должно содержать хотя бы одно число',
      has_char: 'Поле {_field_} должно содержать хотя бы один символ',
      phone_numbers: 'Поле {_field_} может содержать только цифры, запятые и пробелы',
    },
    fields: {
      'Таймаут': {
        min_value: "Поле {_field_} должно быть {min} секунд или больше"
      }
    },
  },
  en: {
    messages: {
      "alpha": "The {_field_} field may only contain alphabetic characters",
      "alpha_num": "The {_field_} field may only contain alpha-numeric characters",
      "alpha_dash": "The {_field_} field may contain alpha-numeric characters as well as dashes and underscores",
      "alpha_spaces": "The {_field_} field may only contain alphabetic characters as well as spaces",
      "between": "The {_field_} field must be between {min} and {max}",
      "confirmed": "The {_field_} field confirmation does not match",
      "digits": "The {_field_} field must be numeric and exactly contain {length} digits",
      "dimensions": "The {_field_} field must be {width} pixels by {height} pixels",
      "email": "The {_field_} field must be a valid email",
      "excluded": "The {_field_} field is not a valid value",
      "ext": "The {_field_} field is not a valid file",
      "image": "The {_field_} field must be an image",
      "integer": "The {_field_} field must be an integer",
      "length": "The {_field_} field must be {length} long",
      "max_value": "The {_field_} field must be {max} or less",
      "max": "The {_field_} field may not be greater than {length} characters",
      "mimes": "The {_field_} field must have a valid file type",
      "min_value": "The {_field_} field must be {min} or more",
      "min": "The {_field_} field must be at least {length} characters",
      "numeric": "The {_field_} field may only contain numeric characters",
      "oneOf": "The {_field_} field is not a valid value",
      "regex": "The {_field_} field format is invalid",
      "required_if": "The {_field_} field is required",
      "required": "The {_field_} field is required",
      "size": "The {_field_} field size must be less than {size}KB",
      "double": "The {_field_} field must be a valid decimal",

      alpha_and_num: 'The {_field_} field may only contain alpha-numeric characters',
      alpha_num_spaces: 'The {_field_} field may only contain alphabetic characters as well as spaces',
      alpha_num_dash: 'The {_field_} field may contain alpha-numeric characters as well as dashes and underscores',
      alpha_num_dash_dot: 'The {_field_} field may contain alpha-numeric characters as well as dashes and underscores and dots',
      alpha_num_dash_spaces: 'The {_field_} field may contain alpha-numeric characters as well as spaces and dashes and underscores',
      template: 'The {_field_} field may contain alpha-numeric characters as well as spaces and symbols _ # №',
      not_zero: 'The {_field_} field must not be 0',
      sms_originator: 'The length of the sender\'s address must be no more than 15 digits or 11 characters (numbers and latin characters, space, period, hyphen, underscore)',
      non_cyrillic: 'The {_field_} field may not contain cyrillic characters',
      viber_originator: 'The length of the sender\'s address must be no more than 11 characters (numbers and latin characters, space, period, hyphen, underscore)',
      max_throughput: 'Incorrect value. Correct format x/y',
      smpp_name: 'Incorrect value. Allowed Latin characters, dashes and underscores',
      non_space: 'The {_field_} field may not contain spaces',
      has_num: 'The {_field_} field must contain at least one numeric characters',
      has_char: 'The {_field_} field must contain at least one alphabetic characters',
      phone_numbers: 'The {_field_} field may only contain numbers, commas and spaces',
    },
    fields: {
      'Timeout': {
        min_value: "The {_field_} field must be {min} seconds or more",
      }
    },
  }});

localize(localStorage.getItem('locale') || 'ru');

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
